import React from "react";
import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import Logo from "./../../../../assets/img/logo-pdf.png"
const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1 solid black",
    paddingBottom: 10,
    marginBottom: 10
  },

  logo: {
    width: 250,
    height: 80
  },

  website: {
    fontSize: 16,
    textAlign: "right",
    width: 300
  }
});

const PDFHeader = () => {
  return (
    <View style={styles.header}>

      {/* LEFT - LOGO */}
      <Image
        style={styles.logo}
        src={Logo}
      />

      {/* RIGHT - WEBSITE */}
      <View style={styles.website}>
        <Text style={{ textAlign: "center", fontWeight: "bold" }}>
          INTERNATIONAL AIR WAYBILL
        </Text>
        <Text style={{ textAlign: "center", opacity: 0.3 }}>
          www.indak.id
        </Text>
      </View>
    </View>
  );
};

export default PDFHeader;